import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import ThemeContextProvider from './context/ThemeContext';
import App from './App';

ReactDOM.render(
    <ThemeContextProvider>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </ThemeContextProvider>,
    document.getElementById('root')
);
